exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basic-layout {\n  color: #636b6f;\n  height: 100vh;\n  font-weight: 100;\n  position: relative;\n}\n.basic-layout .links > a {\n  color: #636b6f;\n  padding: 0 25px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1rem;\n  text-decoration: none;\n  text-transform: uppercase;\n}", ""]);

// exports
